
import { writable, get } from "svelte/store";

const store = writable({});

store.get = async(appId) => {

    const result = await fetch(`api/v1/app-settings/${appId}`);
    if(result.ok) {
        const json = await result.json();
        store.set(json);
    } else {
        store.set({});
    }
}

store.post = async (appId, settings) => {
    
    const storeData = get(store);
    const newData = {...storeData, ...settings};
    const res = await fetch(`api/v1/app-settings/${appId}`, {
        method: 'POST', 
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(newData)
    });
    const body = await res.json();
    if(res.ok) {
        store.set(body);
    }
    
    return {ok: res.ok, body};
}

export default store;